import React from "react";
import Head from "next/head";
import { Page } from "@solace/types";
import { urlFor } from "content";

interface ISEO {
  page?: Page;
  path?: string;
  imgUrl?: string;
  noindex?: boolean;
}

export const SEO = (props: ISEO) => {
  const title = `${props.page?.title} | NuCalm`;
  const sanityImageUrl = props.page?.image?.asset
    ? urlFor(props.page?.image?.asset).width(1200).height(600).url()
    : "https://firebasestorage.googleapis.com/v0/b/nucalmv3-dev.appspot.com/o/Mastermind%2FIgniteScreen.png?alt=media&token=1fd39db7-f560-445e-9c8d-09597cd8de5b";
  const origin =
    typeof window !== "undefined"
      ? window.location.origin
      : process.env.NEXT_PUBLIC_ORIGIN;

  return (
    <Head>
      <title>{title}</title>
      <meta
        name="title"
        content={title}
      />
      {props.page?.description && (
        <meta
          name="description"
          content={props.page.description}
        />
      )}
      {props.noindex && (
        <meta
          name="robots"
          content="noindex"
        />
      )}
      {/* Open Graph / Facebook */}
      <meta
        property="og:type"
        content="website"
      />
      {props.path && (
        <meta
          property="og:url"
          content={`${origin}${props.path}`}
        />
      )}
      <meta
        property="og:title"
        content={title}
      />
      {props.page?.description && (
        <meta
          property="og:description"
          content={props.page?.description}
        />
      )}
      {sanityImageUrl && (
        <meta
          property="og:image"
          content={sanityImageUrl}
        />
      )}
      {props.imgUrl && (
        <meta
          property="og:image"
          content={props.imgUrl}
        />
      )}
      {/* Twitter */}
      {/* <meta property="twitter:card" content="summary_large_image" /> */}
      {props.path && (
        <meta
          property="twitter:url"
          content={`${origin}${props.path}`}
        />
      )}
      <meta
        property="twitter:title"
        content={title}
      />
      {props.page?.description && (
        <meta
          property="twitter:description"
          content={props.page.description}
        />
      )}
      {sanityImageUrl && (
        <meta
          property="twitter:image"
          content={sanityImageUrl}
        />
      )}
      {props.imgUrl && (
        <meta
          property="twitter:image"
          content={props.imgUrl}
        />
      )}
    </Head>
  );
};
